import * as React from 'react';
import * as styles from './client-tags.module.scss';
import TagTableItem from './tagTableItem';
import Tag from '../../../../models/tag';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import Scrollbars from 'react-custom-scrollbars';
import Administrator from '../../../../models/administrator';
import { AssignedUser } from '../../../../models/client';

interface Props {
  tags: Tag[];
  clientUsers: AssignedUser[];
  clientAdministrators: Administrator[];
  clientId: number;
  fetchTagsHandler: () => void;
  deleteTagHandler: (tagId: number, tagName: string) => void;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
}

const TagTable = ({
  tags,
  clientUsers,
  clientAdministrators,
  clientId,
  fetchTagsHandler,
  deleteTagHandler,
  setSuccessMessage,
  setErrorMessage
}: Props) => {
  const [windowSize, setWindowSize] = React.useState<number>(0);

  React.useEffect(() => {
    const resizeHandler = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return (
    <TableContainer className={styles.tableContainer}>
      <Table>
        <TableHead className={styles.tableHead}>
          <TableRow className={styles.tableRow}>
            <TableCell key="color" className={styles.colorColumn} />
            <TableCell key="name" className={styles.nameColumn}>
              TAG NAME
            </TableCell>
            <TableCell key="users" className={styles.usersColumn}>
              PERMISSIONED USERS
            </TableCell>
            <TableCell key="actions" />
          </TableRow>
        </TableHead>
      </Table>
      <Scrollbars autoHide style={{ flex: 1 }}>
        {tags.length === 0 ? (
          <p>There are no tags created for this client.</p>
        ) : (
          <Table>
            <TableBody>
              {tags.map(tag => (
                <TableRow key={tag.tagId} className={styles.tableRow}>
                  <TagTableItem
                    tag={tag}
                    clientId={clientId}
                    windowSize={windowSize}
                    deleteTagHandler={() => deleteTagHandler(tag.tagId, tag.name)}
                    clientUsers={clientUsers}
                    clientAdministrators={clientAdministrators}
                    setSuccessMessage={setSuccessMessage}
                    setErrorMessage={setErrorMessage}
                    fetchTagsHandler={fetchTagsHandler}
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Scrollbars>
    </TableContainer>
  );
};

export default TagTable;
